import { queryOptions } from '@tanstack/react-query'

import { AUDIT_LIST_KEY } from './audit.constants'
import { getAuditListPaged } from './audit.service'
import type { TAuditFilters } from './audit.types'

// Liste sayfası için sayfalı + filtreli sorgu. Anahtar filtreleri içerir → filtre
// değişimi yeni cache girdisi (artık veri gösterilmez).
export function auditPagedQueryOptions(page: number, filters: TAuditFilters) {
  return queryOptions({
    queryKey: [...AUDIT_LIST_KEY, 'paged', page, filters],
    queryFn: () => getAuditListPaged(page, filters),
  })
}
